import { render, staticRenderFns } from "./ReactionBarItem.vue?vue&type=template&id=728bea48&"
import script from "./ReactionBarItem.vue?vue&type=script&lang=ts&"
export * from "./ReactionBarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports